import constants from './../../constants'

const name = (
  paymentMethod,
  defaultName = constants.paymentMethods.DEFAULT_PAYMENT_METHOD.name,
) => {
  const method = constants.paymentMethods.PAYMENT_METHODS.find(
    method => method.paymentMethod === paymentMethod,
  )

  if (!method) {
    return defaultName
  }

  return method.name
}

export default name
